module.exports = __webpack_public_path__ + "media/images/iconSocialLink__accent--dark-7cbfb4a6df7dc2a2b77da1745aaa4130.png";